module.exports = __webpack_public_path__ + "img/login-banner.a87d417b.jpg";